var d3 = $.extend(require("d3-selection"),
    require("d3-shape"),
    require("d3-transition"),
    require("../../utils/d3.utilities")
);

var CenterComponent = require("./center.component");
var ChartComponent = require("./chart.component");

function WindscreenComponent() {
    var moduleOptions = {
        sliceRadius: 300,
        separatorRadius: 250,
        centreRadius: 35,
        padding: 10,
        angle: 0.5 * Math.PI
    };

    var currentContext, plot, windscreen, defs, data;

    function setUpPlot() {
        var wrapper = currentContext
            .append("div")
            .attr("class", "pcg-plot-wrap");

        plot = wrapper
            .append("svg")
            .attr("class", "pcg-plot")
            .attr("width", "600")
            .attr("height", "300");

        var minX = -1 * (moduleOptions.sliceRadius + moduleOptions.padding);
        var minY = -1 * (moduleOptions.sliceRadius + moduleOptions.padding);
        var width = 2 * (moduleOptions.sliceRadius + moduleOptions.padding);
        var height = moduleOptions.sliceRadius + moduleOptions.centreRadius + moduleOptions.padding;

        plot
            .attr("viewBox", `${minX} ${minY} ${width} ${height}`);

        defs = plot.append("defs");
    }

    this.init = function (context, options, windscreenData) {
        if(!windscreenData || !windscreenData.items.length) {
            return;
        }

        $.extend(moduleOptions, options);
        currentContext = d3.select(context);
        data = windscreenData;

        setUpPlot();

        var chart = new ChartComponent(plot, defs, moduleOptions, data);
        chart.render();

        var center = new CenterComponent(plot, defs, moduleOptions, data);
        center.render();
    }

    return this;
}

module.exports = WindscreenComponent;
